export const TEST_ID = {
  appFooter: 'appFooter',
};
